import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useRef, useImperativeHandle } from 'react';
import { cn } from '@utils/cn';
export const ScriptEditor = forwardRef(({ value, onChange, onSelectionChange, className }, ref) => {
    const textareaRef = useRef(null);
    // 暴露textarea ref给父组件
    useImperativeHandle(ref, () => textareaRef.current);
    const handleSelectionChange = () => {
        if (!textareaRef.current || !onSelectionChange)
            return;
        const start = textareaRef.current.selectionStart;
        const end = textareaRef.current.selectionEnd;
        const text = value.substring(start, end);
        onSelectionChange({ start, end, text });
    };
    return (_jsx("div", { className: cn('flex h-full flex-col', className), children: _jsx("textarea", { ref: textareaRef, value: value, onChange: (e) => onChange(e.target.value), onSelect: handleSelectionChange, className: "flex-1 resize-none border-none bg-dark-600 p-6 font-mono text-base leading-relaxed text-gray-100 placeholder:text-gray-500 focus:outline-none", placeholder: "\u5F00\u59CB\u7F16\u5199\u60A8\u7684\u5267\u672C...\n\n\u63D0\u793A\uFF1A\u573A\u666F\u6807\u9898\u53EF\u4EE5\u4F7F\u7528\u4EE5\u4E0B\u683C\u5F0F\uFF1A\n- \u573A\u666F1\uFF1A\u5496\u5561\u5385 - \u767D\u5929\n- INT. \u529E\u516C\u5BA4 - \u767D\u5929\n- \u5916\u666F - \u516C\u56ED - \u508D\u665A\n- \u7B2C\u4E00\u573A \u5BB6\u4E2D\u5BA2\u5385", spellCheck: false }) }));
});
ScriptEditor.displayName = 'ScriptEditor';
